import { useEffect, useState, useRef } from "react";
import { StyleContainerOption, Styles } from "./style";
import { BsCheck, BsChevronDown } from "react-icons/bs";
import { Popover } from "antd";

interface IProps {
  isHidden?: boolean;
  infos: {
    count?: string;
    countNumber?: string;
    max?: string;
    min?: string;
    total?: string;
    avg?: string;
    distinctCount?: string;
  };
}

const mapTitle = {
  total: "合計",
  avg: "平均",
  min: "最小値",
  max: "最大値",
  count: "件数",
  countNumber: "数値の件数",
  distinctCount: "種類",
};

const CellInfoSum = ({ isHidden, infos }: IProps) => {
  const [typeShow, setTypeShow] = useState<keyof IProps["infos"]>(
    Object.keys(infos).length < 6 ? "count" : "total",
  );
  const [open, setOpen] = useState<boolean>(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const container = target.closest(".container_show_item");

      if (container !== elementRef.current) {
        setOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [open]);

  const isShowNumberForDev = localStorage.getItem("dev_isShowNumberForDev");
  const content = (
    <StyleContainerOption className="container_option">
      {Object.keys(mapTitle || {})
        .filter((key) =>
          Object.keys(infos).length < 6
            ? key === "count" || key === "distinctCount"
            : true,
        )
        .map((key) => {
          return (
            <div
              key={key}
              className={`option_item ${
                key === typeShow ? "checked" : "unchecked"
              }`}
              onClick={(e) => {
                setTypeShow(key as typeof typeShow);
                setOpen(false);
                e.stopPropagation();
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
            >
              <div className="icon_checked">
                <BsCheck size={24} />
              </div>
              <div>
                {mapTitle[key as keyof typeof mapTitle]}
                {isShowNumberForDev &&
                  ": " + infos[key as keyof IProps["infos"]]}
              </div>
            </div>
          );
        })}
    </StyleContainerOption>
  );

  useEffect(() => {
    if (Object.keys(infos).length < 6) {
      if (!["count", "distinctCount"].includes(typeShow)) {
        setTypeShow("count");
      }
      return;
    }

    if (!(typeShow in infos)) {
      setTypeShow("total");
    }
  }, [infos, typeShow]);

  return (
    <Styles className="container_show_item" ref={elementRef}>
      <Popover content={content} open={open && !isHidden}>
        <div onClick={() => setOpen(true)} className="container_show">
          <div>
            <span>
              {mapTitle[typeShow as keyof typeof mapTitle]}:{" "}
              {infos[typeShow as keyof IProps["infos"]]}
            </span>

            <BsChevronDown size={15} />
          </div>
        </div>
      </Popover>
    </Styles>
  );
};
export default CellInfoSum;
